import Vue from 'vue'
import VueRouter from 'vue-router'

import Dashboard from '../views/Dashboard.vue'

import Admin from '../views/Admin.vue'

import Settings from '../views/Settings.vue'

import Users from '../views/Users.vue'
import User from '../views/User.vue'

import Entities from '../views/Entities'
import Entity from '../views/Entity'

import Materials from '../views/Materials'
import Material from '../views/Material'

import Assemblies from '../views/Assemblies'
import Assembly from '../views/Assembly'

import Bifold from '../views/BifoldForm'

import Templates from '../views/Templates'
import Template from '../views/Template'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Dashboard
  },
  { path: "/", component: Dashboard },

  { path: "/admin", component: Admin },

  { path: "/settings", component: Settings },

  { path: "/bifolds", component: Bifold },
  { path: "/bifold", component: Bifold },
  { path: "/bifold/:id", component: Bifold, props: true },

  { path: "/materials", component: Materials },
  { path: "/material", component: Material },
  { path: "/material/:id", component: Material, props: true },

  { path: "/users", component: Users },
  { path: "/user", component: User },
  { path: "/user/:id", component: User, props: true },

  { path: "/entities", component: Entities },
  { path: "/entity", component: Entity },
  { path: "/entity/:id", component: Entity, props: true },

  { path: "/assemblies", component: Assemblies },
  { path: "/assembly", component: Assembly },
  { path: "/assembly/:id", component: Assembly, props: true },

  { path: "/templates", component: Templates },
  { path: "/template", component: Template },
  { path: "/template/:id", component: Template, props: true },

  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

export default router
